import { SUBJECTIVE_ORTHO_DRAFT_KEY } from '../pages/ortho/constants.js';
import { NEURO_DRAFT_KEY } from '../pages/neuro/constants.js';
import { CARDIO_DRAFT_KEY } from '../pages/cardio/constants.js';

// Scopes any localStorage key to the current user so different accounts never share data
export const userKey = (base) => `${base}_${localStorage.getItem('auth_email') || 'guest'}`;

export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('auth_token') || ''}`,
});

export const getAuthName  = () => localStorage.getItem('auth_name')  || '';
export const getAuthEmail = () => localStorage.getItem('auth_email') || '';

const DRAFT_BASES = [
  SUBJECTIVE_ORTHO_DRAFT_KEY,
  NEURO_DRAFT_KEY,
  CARDIO_DRAFT_KEY,
];

export const logout = (navigate) => {
  const email = localStorage.getItem('auth_email') || 'guest';
  DRAFT_BASES.forEach(base => {
    try { localStorage.removeItem(`${base}_${email}`); } catch {}
  });
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_name');
  localStorage.removeItem('auth_email');
  navigate('/');
};
